var ErrorListener = require("./antlr4/error/ErrorListener").ErrorListener;

function HCPGrammarErrorListener(expressionErrors) {
  ErrorListener.call(this);
  this.ExpressionErrors = expressionErrors;
  return this;
}

HCPGrammarErrorListener.prototype = Object.create(ErrorListener.prototype);
HCPGrammarErrorListener.prototype.constructor = HCPGrammarErrorListener;

HCPGrammarErrorListener.prototype.syntaxError = function(
  recognizer,
  offendingSymbol,
  line,
  column,
  msg,
  e
) {
  this.ExpressionErrors.push({
    LineNumber: line,
    CharPositionInLine: column,
    Message: msg
  });
};

exports.HCPGrammarErrorListener = HCPGrammarErrorListener;
